import { IBillingAddress, IUserAddress } from "@common/eircode/Interface/IAddressForm";

export const getStateToPayload = (formData: IUserAddress): IBillingAddress => ({
    postalCode: formData.billingAddress.postalCode,
    city: formData.billingAddress.city,
    area: formData.billingAddress.area,
    street: formData.billingAddress.street,
    buildingName: formData.billingAddress.buildingName,
    buildingType: formData.billingAddress.buildingType,
    streetQualifier: formData.billingAddress.streetQualifier,
    streetNumber: formData.billingAddress.streetNumber,
    postalBox: formData.billingAddress.postalBox,
    enablePostalBox: formData.billingAddress.enablePostalBox,
    flatNumber: formData.billingAddress.flatNumber,
    proofOfAddress: formData.billingAddress.proofOfAddress,
});
